
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-0bc3e1fc\",\"scoped\":false,\"hasInlineConfig\":true}!sass-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Dashboard.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Dashboard.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0bc3e1fc\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Dashboard.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/private/Dashboard.vue
// module id = 594
// module chunks = 0